// extracted by mini-css-extract-plugin
module.exports = {"playerselectorModal":"_e4ab6eb","gameModalFit":"_0554fdc","flexFull":"_cab4892","desktopEmbedded":"_ba623f8","flexFullFit":"_087b3fd"};